import React from 'react';
import styled from 'styled-components';

import layout from '@/public/banner-contact.webp';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';

export const ContactLayout = ({ children }) => {
  return <Layout className="main">{children}</Layout>;
};

const Layout = styled.div`
  flex: 1;
  ${backgroundImageMixin(layout.src)}
`;
